// src/components/common/ReportCard.js

import React from 'react';

const ReportCard = ({ title, children, className = '' }) => {
  return (
    <div className={`bg-white rounded-lg shadow-md p-4 sm:p-6 ${className}`}>
      <h3 className="text-xl font-semibold text-gray-800 mb-4">{title}</h3>
      <div className="w-full h-64 flex items-center justify-center"> {/* Fixed height for the chart area */}
        {children}
      </div>
    </div>
  );
};

export default ReportCard;
